import { ISpidProviderButton } from './SpidLoginButton';

/**
 * Funzione per l'identity provider utile per il redirect ai servizi SPID
 * @description Aggiornare in caso di nuovi provider
 */
export function getIdentityProvider(provider: ISpidProviderButton) {
  switch (provider.entity_id) {
    case 'https://posteid.poste.it':
      return 'poste';
    case 'https://loginspid.aruba.it':
      return 'arubaid';
    case 'https://spid.intesa.it':
      return 'intesa';
    case 'https://identity.infocert.it':
      return 'infocert';
    case 'https://id.lepida.it/idp/shibboleth':
      return 'lepida';
    case 'https://idp.namirialtsp.com/idp':
      return 'namirialid';
    case 'https://spid.register.it':
      return 'spiditalia';
    case 'https://identity.sieltecloud.it':
      return 'sielte';
    case 'https://login.id.tim.it/affwebservices/public/saml2sso':
      return 'tim';
    case 'https://spid.teamsystem.com/idp':
      return 'teamsystemid';
    case 'https://id.eht.eu':
      return 'etnahitech';
    case 'https://loginspid.infocamere.it':
      return 'infocamere';
    default:
      return provider.entity_id;
  }
}
